import { PanelLayout } from '@/components/Layouts'
import { BookLayout } from '@/features/book/components/Book/BookLayout'
import { BookRoot } from '@/features/book/routes'

export const getMixedRoutes = (isLoggedIn: boolean) => {
  return [
    {
      path: '/',
      index: !isLoggedIn,
      element: (
        <PanelLayout useOpacity={true} fromBookNow={true}>
          <BookRoot />
        </PanelLayout>
      ),
    },
  ]
}
